import LoopFront from "loop-front";


const CustomActions = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
}

const CustomActivities = {
    LOGIN: 'login'
}


class Auth extends LoopFront<typeof CustomActions, {}, typeof CustomActivities> {
    constructor() {
        super('users', CustomActions, {}, CustomActivities);
    }

    getUserId = () => localStorage.getItem('userId');

}

export const AuthModel = new Auth();